
import { defineComponent, ref, onMounted, computed } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import router from "@/router";
import Roles, { exportRoleData, exportPDFRoles } from "@/core/data/role";
import { Role, getRoles, deleteRole } from "@/core/data/role";
import moment from "moment";
import store from "@/store";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { getUserById, getUsers } from "@/core/data/users";
import { getError } from "@/core/helpers/utils";

export default defineComponent({
  name: "Role-listing",
  components: {
    Datatable,
  },
  setup() {
    const checkedRole = ref([]);
    const selectedStatus = ref("");

    let selectedItem = ref({});
    let selectedUser = ref();

    const total = ref<any>(0);
    const currentPage = ref<any>(1);
    const showSearchPanel = ref<boolean>(true);
    const selectAllRole = ref<boolean>(false);
    const isLoading = ref<boolean>(true);
    const search = ref<string>("");
    const tableData = ref<Array<Role>>(Roles);
    const userList = ref<any>({});
    const searchData = ref<any>({});
    const userOptionList = ref<any>([]);
    const userIdList = ref<Array<any>>([]);
    const branch = ref([]);
    const course = ref([]);
    const universiteies = ref([]);
    const getListItems = function (pageNumber) {
      console.log("selectedUser.value", selectedUser.value);
      isLoading.value = true;
      if (pageNumber) {
        currentPage.value = pageNumber;
      }
      return new Promise((res, rej) => {
        getRoles(
          currentPage.value,
          searchData.value,
          selectedStatus.value,
          selectedUser.value
        ).then((resObj: any) => {
          isLoading.value = false;
          total.value = resObj.count;
          tableData.value.splice(0, tableData.value.length, ...resObj.data);
          console.log("tableData", tableData.value);
          let promiseList: any = [];
          tableData.value.forEach((item) => {
            if (userIdList.value.indexOf(item.created_by) == -1) {
              userIdList.value.push(item.created_by);
              promiseList.push(getUserName(item.created_by));
            }
            Promise.all(promiseList).then(() => {
              res(resObj);
            });
          });
          console.log("tableData", tableData.value);
        });
      });
    };
    const getUserName = async function (id) {
      if (!userList.value[id]) {
        let userData = await getUserById(id);
        userList.value[id] = userData;
      }
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs("Roles Listing", ["Apps", "Roles"]);
      getListItems(1);
    });

    const userListComputed = computed(() => {
      return [
        { id: "", name: "All" },
        ...userOptionList.value.map((item) => ({
          name: item.name,
          ...item,
        })),
      ];
    });

    const asyncUser = (query) => {
      console.log("query", query);
      getUsers(1, query).then((resObj: any) => {
        userOptionList.value.splice(
          0,
          userOptionList.value.length,
          ...resObj.data
        );
      });
    };
    const deleteFewSites = () => {
      checkedRole.value.forEach((item) => {
        deleteRole(item);
      });
      checkedRole.value.length = 0;
    };
    const exportFewSites = () => {
      exportRoleData(
        selectAllRole.value ? "all" : checkedRole.value.join(",")
      ).then(() => {
        Swal.fire("Export!", "Your Role has been exported.", "success");
      });
    };
    const exportPDFRolesHanlder = () => {
      exportPDFRoles(
        selectAllRole.value ? "all" : checkedRole.value.join(",")
      ).then(() => {
        Swal.fire("Export!", "Your Role has been exported.", "success");
      });
    };
    const deleteRoleItem = (item) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          deleteRole(item)
            .then(() => {
              Swal.fire("Deleted!", "Your Role has been deleted.", "success");
              getListItems(currentPage.value);
            })
            .catch((err) => {
              Swal.fire({
                html: getError(err),
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Ok, got it!",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
            });
        }
      });
    };
    const searchItems = () => {
      getListItems(1);
    };

    const setSelectedItem = (item) => {
      selectedItem.value = item;
    };

    const addRole = (id) => {
      if (id) {
        router.push({ name: "apps-edit-role", params: { id: id } });
      } else {
        router.push({ name: "apps-add-role" });
      }
    };
    const permissionRoleItem = (id) => {
      router.push({ name: "apps-permission-role", params: { id: id } });
    };
    const onPageChange = (pageNumber) => {
      return getListItems(pageNumber);
    };

    const userData = computed(() => {
      return store.getters.currentUser;
    });
    const hasCreate = computed(() => {
      return ["ADMIN"].indexOf(userData.value.role) > -1;
    });
    const hasEdit = computed(() => {
      return ["ADMIN"].indexOf(userData.value.role) > -1;
    });
    const hasDelete = computed(() => {
      return ["ADMIN"].indexOf(userData.value.role) > -1;
    });
    const tableHeader = computed(() => {
      let columnsArr = [
        {
          name: " ",
          key: "checkbox",
          sortable: false,
        },
        {
          name: "Name",
          key: "name",
          sortable: false,
        },
      ];
      if (hasEdit.value || hasDelete.value) {
        columnsArr.push({
          name: "Actions",
          key: "actions",
          sortable: false,
        });
      }
      return columnsArr;
    });
    return {
      addRole,
      setSelectedItem,
      selectedItem,
      tableData,
      tableHeader,
      deleteRole,
      getRoles,
      deleteRoleItem,
      search,
      searchItems,
      checkedRole,
      deleteFewSites,
      moment,
      total,
      currentPage,
      isLoading,
      onPageChange,
      userData,
      hasCreate,
      hasEdit,
      hasDelete,
      selectedStatus,
      getUserName,
      userList,
      userListComputed,
      selectedUser,
      asyncUser,
      exportFewSites,
      exportPDFRolesHanlder,
      selectAllRole,
      showSearchPanel,
      searchData,
      branch,
      universiteies,
      course,
      permissionRoleItem,
    };
  },
});
